document.addEventListener('DOMContentLoaded', function () {
    const mapContainer = document.getElementById('contact-map');
    if (!mapContainer) return;

    // Al Barsha 1 Coordinates
    const dubaiCoords = [25.1087378, 55.1838021];
    const zoomLevel = 17;

    // Initialize Map
    const map = L.map('contact-map', {
        zoomControl: false, // Disable default zoom controls to use our custom ones
        scrollWheelZoom: false // Better UX on contact pages
    }).setView(dubaiCoords, zoomLevel);

    // Add Tile Layer (Esri World Street Map provides English labels by default)
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
    }).addTo(map);

    // Custom Marker
    const customIcon = L.divIcon({
        className: 'custom-div-icon',
        html: `
                <div style="
                    background-color: #facd23;
                    width: 30px;
                    height: 30px;
                    border-radius: 50% 50% 50% 0;
                    transform: rotate(-45deg);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
                    border: 3px solid white;
                ">
                    <div style="
                        width: 10px;
                        height: 10px;
                        background-color: white;
                        border-radius: 50%;
                        transform: rotate(45deg);
                    "></div>
                </div>`,
        iconSize: [30, 42],
        iconAnchor: [15, 42]
    });

    const marker = L.marker(dubaiCoords, { icon: customIcon }).addTo(map);
    marker.bindPopup('<b>Reim Real Estate Brokerage</b><br>Al Attar Business center - Sheikh Zayed Rd - Al Barsha First - Al Barsha - Dubai - United Arab Emirates').openPopup();

    // Custom Controls Functionality
    const zoomIn = document.getElementById('map-zoom-in');
    const zoomOut = document.getElementById('map-zoom-out');
    const locate = document.getElementById('map-locate');
    const share = document.getElementById('map-share');
    const showMap = document.getElementById('btn-show-map');

    if (zoomIn) zoomIn.addEventListener('click', () => map.zoomIn());
    if (zoomOut) zoomOut.addEventListener('click', () => map.zoomOut());
    if (locate) locate.addEventListener('click', () => map.setView(dubaiCoords, zoomLevel));

    if (share) {
        share.addEventListener('click', function () {
            const shareData = {
                title: 'Our Location',
                text: 'Check out our Dubai office location:',
                url: window.location.href
            };

            if (navigator.share) {
                navigator.share(shareData).catch(err => {
                    // console.log('Error sharing:', err);
                });
            } else {
                // Fallback: Copy to clipboard
                const dummy = document.createElement('input');
                document.body.appendChild(dummy);
                dummy.value = window.location.href;
                dummy.select();
                document.execCommand('copy');
                document.body.removeChild(dummy);

                // Show a subtle toast or alert
                const btn = this;
                const originalHtml = btn.innerHTML;
                btn.innerHTML = '<i class="fas fa-check"></i>';
                setTimeout(() => {
                    btn.innerHTML = originalHtml;
                }, 2000);
            }
        });
    }

    if (showMap) {
        showMap.addEventListener('click', function () {
            window.open('https://www.google.com/maps?q=' + dubaiCoords[0] + ',' + dubaiCoords[1], '_blank');
        });
    }

    // Ensure map resizes correctly
    setTimeout(function () {
        map.invalidateSize();
    }, 500);
});